import { Container, Section } from "@/components/ui/section";
import { TrendingUp, Zap, Clock, Target, X, Check } from "lucide-react";

const metrics = [
  {
    icon: TrendingUp,
    value: "10x",
    label: "more customer interviews"
  },
  {
    icon: Zap,
    value: "5–10",
    label: "new assets monthly"
  },
  {
    icon: Clock,
    value: "Weeks → Minutes",
    label: "for case study creation"
  },
  {
    icon: Target,
    value: "Always",
    label: "sales equipped with proof"
  }
];

export const Value = () => {
  return (
    <Section id="value" className="bg-background">
      <Container>
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
            More interviews. More stories. More revenue-proof. Less work.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {metrics.map((metric, index) => (
            <div key={index} className="text-center p-6 bg-card border border-border rounded-lg hover:shadow-[var(--shadow-soft)] transition-all duration-300">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <metric.icon className="w-6 h-6 text-primary" />
              </div>
              <div className="text-3xl font-bold text-foreground mb-2">{metric.value}</div>
              <div className="text-sm text-muted-foreground">{metric.label}</div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="relative bg-card rounded-lg p-8 border-2 border-destructive/20 hover:border-destructive/30 transition-all duration-300">
            <div className="absolute -top-4 left-6 bg-destructive/10 text-destructive px-4 py-1.5 rounded-full text-sm font-semibold flex items-center gap-2">
              <X className="w-4 h-4" />
              Before Casey
            </div>
            <ul className="space-y-4 mt-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 bg-destructive/10 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <X className="w-3.5 h-3.5 text-destructive" />
                </div>
                <span className="text-muted-foreground">2–3 interviews per quarter</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 bg-destructive/10 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <X className="w-3.5 h-3.5 text-destructive" />
                </div>
                <span className="text-muted-foreground">Long production cycles</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 bg-destructive/10 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <X className="w-3.5 h-3.5 text-destructive" />
                </div>
                <span className="text-muted-foreground">Sparse proof for sales</span>
              </li>
            </ul>
          </div>

          <div className="relative bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg p-8 border-2 border-primary/30 hover:border-primary/50 hover:shadow-[var(--shadow-soft)] transition-all duration-300">
            <div className="absolute -top-4 left-6 bg-primary text-primary-foreground px-4 py-1.5 rounded-full text-sm font-semibold flex items-center gap-2">
              <Check className="w-4 h-4" />
              With Casey
            </div>
            <ul className="space-y-4 mt-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 bg-primary/20 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-3.5 h-3.5 text-primary" />
                </div>
                <span className="text-foreground font-medium">Dozens of interviews each month</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 bg-primary/20 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-3.5 h-3.5 text-primary" />
                </div>
                <span className="text-foreground font-medium">Constant flow of stories and insights</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 bg-primary/20 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-3.5 h-3.5 text-primary" />
                </div>
                <span className="text-foreground font-medium">A complete, searchable collateral library</span>
              </li>
            </ul>
          </div>
        </div>
      </Container>
    </Section>
  );
};
